import { render, staticRenderFns } from "./SysCategoryModal.vue?vue&type=template&id=d9e821da&scoped=true"
import script from "./SysCategoryModal.vue?vue&type=script&lang=js"
export * from "./SysCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./SysCategoryModal.vue?vue&type=style&index=0&id=d9e821da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e821da",
  null
  
)

export default component.exports